import * as React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'Maven',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.java.maven.body',
        defaultMessage:
          'Add the following dependency to your POM and replace {VERSION} with the version number you want to use.',
      }),
    },
    command: `<dependency>
<groupId>com.stripe</groupId>
<artifactId>stripe-java</artifactId>
<version>{VERSION}</version>
</dependency>`,
    large: true,
  },
  {
    label: 'Gradle',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.java.gradle.body',
        defaultMessage:
          'Add the dependency to your build.gradle file and replace {VERSION} with the version number you want to use.',
      }),
    },
    command: 'implementation "com.stripe:stripe-java:{VERSION}"',
  },
  {
    label: 'GitHub',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.java.github.body',
        defaultMessage: 'Download the JAR directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.java.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-java/releases/latest',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.java.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.java.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.java.setup.heading',
      defaultMessage: 'Set up your server',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.java.setup.body',
      defaultMessage:
        'Add the dependency to your build and import the library. Alternatively, if you’re starting from scratch and need a sample pom.xml file (for Maven), download the project files using the link in the code editor.',
    }),
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = (name) =>
  `java -cp target/${name ||
    'accept-card-payment'}-1.0.0-SNAPSHOT-jar-with-dependencies.jar com.stripe.sample.Server`;
